import React from "react";
import { Field } from "redux-form";
import PropTypes from "prop-types";
import {
  RenderInput,
  RenderSelect,
} from "../../Common/InputComponents/Inputs.jsx";
import {
  required,
  minLength2,
  validateCndIdentifier,
} from "../../../util/validations";
import {
  tooltipFluorophores,
  tooltipIdentifier,
} from "../../Common/Misc/Tooltips.jsx";

const genomeOptions = ["Homo sapiens", "Mus musculus", "Rattus norvegicus"];

const fluorophoreOptions = [
  { name: "FAM", value: "FAM" },
  { name: "HEX", value: "HEX" },
  { name: "Cy5", value: "Cy5" },
  { name: "Cy5.5", value: "Cy5_5" },
];

export const CopyNumberDeterminationIdentifier = ({ input, custom, index }) => {
  const validationErrorDetails =
    (custom &&
      custom.validatedAssayDetails &&
      custom.validatedAssayDetails[index]) ||
    {};

  const copyNumberDeterminationIdentifier = input && input.name;

  const changeTargetUUID = (targetUUID) => {
    custom.change(`${copyNumberDeterminationIdentifier}.uuid`, targetUUID);
    let inputIndex = copyNumberDeterminationIdentifier
      .split("]")[0]
      .split("[")[1];
    custom.actions.clearValidationMessages(inputIndex);
  };
  const resetUUID = () => {
    custom.change(`${copyNumberDeterminationIdentifier}.uuid`, "");
  };

  return (
    <div className="inputs">
      <div className="row">
        <div className="col">
          <div className="form-group">
            <Field
              name={`${copyNumberDeterminationIdentifier}.identifier`}
              placeholder="e.g., BRAF or chr7:55247443-55256642"
              className="form-control"
              type="text"
              component={RenderInput}
              label="Identifier:"
              validate={[required, minLength2, validateCndIdentifier]}
              tooltip={tooltipIdentifier("CopyNumberDetermination")}
              serverValidation={validationErrorDetails}
              changeTargetUUID={changeTargetUUID}
              onChange={resetUUID}
            />
          </div>
        </div>
        <div className="col">
          <div className="form-group">
            <Field
              name={`${copyNumberDeterminationIdentifier}.genome`}
              className="form-control"
              component={RenderSelect}
              label="Genome:"
            >
              {genomeOptions &&
                genomeOptions.map((option) => {
                  return (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  );
                })}
            </Field>
          </div>
        </div>
        <div className="col">
          <div className="form-group">
            <Field
              name={`${copyNumberDeterminationIdentifier}.fluorophores`}
              className="form-control"
              component={RenderSelect}
              label="Fluorophore(s):"
              tooltip={tooltipFluorophores}
            >
              {fluorophoreOptions &&
                fluorophoreOptions.map((option) => {
                  return (
                    <option key={option.name} value={option.value}>
                      {option.name}
                    </option>
                  );
                })}
            </Field>
          </div>
        </div>
      </div>
    </div>
  );
};

CopyNumberDeterminationIdentifier.propTypes = {
  fields: PropTypes.object.isRequired,
};
